module.exports = __webpack_public_path__ + "img/img_logo_niubiz_on_white.66ee2e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_logo_niubiz_on_white.svg
// module id = ./src/assets/images/img_logo_niubiz_on_white.svg
// module chunks = 20 21